import { render } from "./ImageExpanded.vue?vue&type=template&id=03632302&scoped=true"
import script from "./ImageExpanded.vue?vue&type=script&lang=js"
export * from "./ImageExpanded.vue?vue&type=script&lang=js"

import "./ImageExpanded.vue?vue&type=style&index=0&id=03632302&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03632302"]])

export default __exports__